import { css } from '@emotion/css';
import { colors } from 'constants/theme';
import bgHome from '../../assets/images/bg/bgHome.jpg';

const registerPageStyle = {
    container: css`
        /* background: url(${bgHome}) no-repeat center; */
        background-color: white;
        background-size: cover;
        height: 1000px;
        justify-content: center;
        align-items: center;
        display: flex;
    `,
    image: css`
        width: 443px;
        height: 113px;
        align-self: center;
        margin-top: -10px;
        position: relative;
    `,
    viewForm: css`
        background-color: #094246;
        width: 880px;
        height: 750px;
        display: flex;
        flex-direction: column;
        border: 1px solid #ddca8c;

        .containerInput {
            margin-top: 80px;
            padding-left: 40px;
            padding-right: 40px;
        }
    `,

    submitButton: css`
        background-image: linear-gradient(87deg, #e5bd61, #fcf3d4, #e5bd61);
        color: ${colors.primary};
        font-size: 20px;
        padding: 10px 0;
        border: none;
        width: 100%;
        cursor: pointer;
        text-align: center;
        line-height: 1;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-appearance: button;
        border-radius: 3px;
        height: auto;
        transition: background-color 0.3s ease;
        font-family: 'UTM AvoBold';

        &:hover {
            background-color: #f7e0a3;
        }
    `,
};

export default registerPageStyle;
